import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import ShowTimeslots from './ShowTimeslots';
import moment from 'moment';

const CURRENT_STEP = 'SCHEDULE';

class Schedule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invalid: '',
      endTime: '',
      startTime: '',
      stations: 1,
      timeSlot: '',
      firstAppt: '',
      perTimeSlot: 5,
      showTimeslots: false,
      totalTimeslots: '',
      totalToSchedule: '',
    }
  }

  handleValidate = () => {
    const {
      date,
      startTime,
      endTime,
      firstAppt,
      perTimeSlot,
      timeSlot,
      stations,
      totalToSchedule
    } = this.state;

    const errors = {};

    if (!date) {
      errors.date = 'Please select a date.';
    }

    if (!timeSlot) {
      errors.timeSlot = 'Please select a time slot.';
    }

    if (!perTimeSlot) {
      errors.perTimeSlot = 'Please enter vaccines per time slot.';
    }

    if (!stations) {
      errors.stations = 'Please select the number of stations.';
    }

    if (!startTime) {
      errors.startTime = 'Please select a start time.'
    }

    if (!endTime) {
      errors.endTime = 'Please select an end time.'
    }

    if (startTime > endTime) {
      errors.endTime = 'End time must exceed start time.'
    }

    this.setState({ invalid: errors });

    if (!errors.startTime &&
      !errors.endTime &&
      !errors.firstAppt &&
      !errors.perTimeSlot &&
      !errors.timeSlot &&
      !errors.stations
    ) {
      this.props.handleData({ startTime, endTime, firstAppt, perTimeSlot, timeSlot, stations, totalToSchedule });
    }
  }

  handleSetDate = (date) => {
    const { startTime, endTime } = this.state;

    this.setState({ date: date }, () => {

      if (startTime) {
        this.handleStartTime(startTime);
      }
      if (endTime) {
        this.handleEndTime(endTime);
      }
    });
  }

  handleStartTime = (time) => {
    const { date } = this.state;
    const appt = moment(date).set('hour', moment(time).get('h')).set('minute', moment(time).get('m')).toDate();

    this.setState({ startTime: appt, firstAppt: appt }, () => {
      this.calculateTotalToSchedule();
    })
  }

  handleEndTime = (time) => {
    const { date } = this.state;
    const appt = moment(date).set('hour', moment(time).get('h')).set('minute', moment(time).get('m')).toDate();

    this.setState({ endTime: appt }, () => {
      this.calculateTotalToSchedule();
    })
  }

  calculateTotalToSchedule = () => {
    const { startTime, endTime, stations, timeSlot, perTimeSlot, totalTimeslots } = this.state;

    if (!startTime || !endTime || !timeSlot || !perTimeSlot || !stations) {
      return;
    }

    if (moment(startTime).isSame(moment(endTime))) {
      this.setState({ totalToSchedule: 0 })
    }
    else {
      const timeSlotsIntervals = [];
      const current = moment(startTime);

      while (current < endTime) {
        timeSlotsIntervals.push(current.format('YYYY-MM-DD HH:mm'));
        current.add(timeSlot, 'minutes');
      }

      if (totalTimeslots.toString() !== timeSlotsIntervals.toString()) {
        this.setState({ totalTimeslots: timeSlotsIntervals });
      }
      this.setState({ totalToSchedule: timeSlotsIntervals.length * perTimeSlot * stations })
    }

  }

  render() {
    const {
      date,
      invalid,
      endTime,
      startTime,
      stations,
      timeSlot,
      perTimeSlot,
      showTimeslots,
      totalTimeslots,
      totalToSchedule,
    } = this.state;

    if (this.props.currentStep !== CURRENT_STEP) {
      return null;
    }

    return <div className="card axs-shadow">
      <div className="card-body">
        <h3>Mass Schedule <small>Schedule</small></h3>

        <hr />

        <div className="row">
          <div className="col-12">
            <div className="alert alert-primary" role="alert">
              Begin a mass schedule by completing the form below.
            </div>

            <ShowTimeslots
              stations={stations}
              perTimeSlot={perTimeSlot}
              showTimeslots={showTimeslots}
              totalTimeslots={totalTimeslots}
              hideTimeslots={() => this.setState({ showTimeslots: false })}
            />

            <form className="needs-validation">
              <div className="form-row">

                <div className="form-group col-4">
                  <label>Date</label> <br />
                  <DatePicker
                    minDate={new Date()}
                    selected={this.state.date}
                    onChange={date => this.handleSetDate(date)}
                    className={`form-control ${invalid.date ? 'is-invalid' : ''}`}
                    dateFormat="MMMM dd, yyyy"
                    wrapperClassName="w-100"
                  />
                  {invalid.date && <div className="text-danger"><small>{invalid.date}</small></div>}
                </div>

                <div className="form-group col">
                  <label>Start Time</label> <br />
                  <DatePicker
                    disabled={!date}
                    showTimeSelect
                    showTimeSelectOnly
                    minTime={moment().set('hours', 6).set('minute', 0).toDate()}
                    maxTime={moment().set('hours', 17).set('minute', 0).toDate()}
                    selected={startTime}
                    onChange={time => this.handleStartTime(time)}
                    timeFormat="h:mm aa"
                    dateFormat="h:mm aa"
                    timeCaption="Time"
                    timeIntervals={15}
                    wrapperClassName="w-100"
                    className={`form-control ${invalid.startTime ? 'is-invalid' : ''}`}
                  />
                  {invalid.startTime && <div className="text-danger"><small>{invalid.startTime}</small></div>}
                </div>

                <div className="form-group col">
                  <label>End Time</label> <br />
                  <DatePicker
                    disabled={!date}
                    showTimeSelect
                    showTimeSelectOnly
                    selected={endTime}
                    minTime={startTime ? startTime : moment().set('hours', 6).set('minute', 0).toDate()}
                    maxTime={moment().set('hours', 17).set('minute', 0).toDate()}
                    onChange={time => this.handleEndTime(time)}
                    dateFormat="hh:mm aa"
                    timeFormat="hh:mm aa"
                    timeCaption="Time"
                    timeIntervals={15}
                    wrapperClassName="w-100"
                    className={`form-control ${invalid.endTime ? 'is-invalid' : ''}`}
                  />
                  {invalid.endTime && <div className="text-danger"><small>{invalid.endTime}</small></div>}
                </div>

                <div className="form-group col-4">
                  <label>Time Slots</label>
                  <select
                    className="form-control"
                    defaultValue={timeSlot}
                    onChange={e => {
                      this.setState({ timeSlot: e.target.value ? parseInt(e.target.value) : '' }, () => {
                        this.calculateTotalToSchedule();
                      })
                    }}
                  >
                    <option />
                    <option value="5">5 minutes</option>
                    <option value="10">10 minutes</option>
                    <option value="15">15 minutes</option>
                    <option value="30">30 minutes</option>
                  </select>
                  {invalid.timeSlot && <div className="text-danger"><small>{invalid.timeSlot}</small></div>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col">
                  <label>Vaccines Per Time Slot</label>
                  <input
                    min="1"
                    type="number"
                    className="form-control"
                    defaultValue={perTimeSlot}
                    onChange={e => {
                      this.setState({ perTimeSlot: parseInt(e.target.value) }, () => {
                        this.calculateTotalToSchedule();
                      })
                    }}
                  />
                  {invalid.perTimeSlot && <div className="text-danger"><small>{invalid.perTimeSlot}</small></div>}
                </div>

                <div className="form-group col">
                  <label>Stations</label>
                  <select
                    className="form-control"
                    defaultValue={stations}
                    onChange={e => {
                      this.setState({ stations: parseInt(e.target.value) }, () => {
                        this.calculateTotalToSchedule();
                      })
                    }}
                  >
                    <option />
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  {invalid.stations && <div className="text-danger"><small>{invalid.stations}</small></div>}
                </div>

                <div className="form-group col">
                  <label>Total to Schedule</label>
                  <div className="input-group">
                    <input
                      disabled
                      type="text"
                      className="form-control"
                      value={totalToSchedule}
                    />
                    <div className="input-group-append">
                      <button
                        type="button"
                        onClick={() => this.setState({ showTimeslots: true })}
                        disabled={!totalTimeslots}
                        className={`btn ${!totalTimeslots ? 'btn-outline-secondary' : 'btn-primary'}`}
                      >
                        <small>View Timeslots</small>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="card-footer">
        <div className="row text-right">
          <div className="col-sm-4 pr-1">
            <button type="button" onClick={this.handleValidate} className="btn btn-primary btn-block">Next</button>
          </div>
        </div>
      </div>
    </div >
  }
}

export default Schedule;